module.exports = __webpack_public_path__ + "static/hero-f2fd8aa0c2687dc6c4eb072a2b849944.jpg";